import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/first-place.png")